import type { State } from '../types.tsx';

export const isDialogOpen = (state: State): boolean => state.ui.requiresConfirmation;

export const isInProgress = (state: State): boolean => state.ui.deleteInProgress;
